import React, { useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Card,
  CardContent,
  Box
} from '@mui/material';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { baseURL, config, requestID } from '../../../common/utils';
import axios from 'axios';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const Accreditation = () => {
  const [loading, setLoading] = useState(false);
  const [accreditationData, setAccreditationData] = useState({ message: '', accreditation_status: false });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [liveStatus, setLiveStatus] = useState('Not Accredited');
  const [approve, setApproved] = useState(false);

  const viewStatus = async () => {
    try {
      setLoading(true);
      const payload = { requestID: requestID() };

      const res = await axios.post(`${baseURL}elections/checkAccreditationStatus`, payload, config);
      console.log("Check Accreditation Response:", res.data);

      setLiveStatus(res.data.accreditation_status1);
      if (res.data.status) setApproved(true);
      setAccreditationData(res.data || { message: '', accreditation_status: false });
    } catch (error) {
      console.error("Error fetching status:", error);
      setAccreditationData({ message: 'Failed to load status.', accreditation_status: false });
    } finally {
      setLoading(false);
    } 
  };

  const performAccreditation = async () => {
    try {
      setLoading(true);
      const payload = { requestID: requestID() };

      const res = await axios.post(`${baseURL}elections/approveAccreditation`, payload, config);
      console.log("Approve Accreditation Response:", res.data);

      setLiveStatus('Approved');
      setApproved(true);
      setAccreditationData(res.data || { message: '', accreditation_status: false });
    } catch (error) {
      console.error("Error performing accreditation:", error);
      setAccreditationData({ message: 'Failed to perform accreditation.', accreditation_status: false });
    } finally {
      setLoading(false);
    }
  };

  const toggleDialog = () => {
    setDialogOpen(!dialogOpen);
  };

  useEffect(() => {
    viewStatus();
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Accreditation Status</IonTitle>
        </IonToolbar>
      </IonHeader>

    <IonContent className="ion-padding">
      <Box display="flex" justifyContent="center" mt={4} px={2}>
        <Card sx={{ maxWidth: 500, width: '100%' }}>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            {loading ? (
              <CircularProgress />
            ) : (
              <>
                <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
                  {liveStatus === 'Approved' || liveStatus === 'Accredited' ? (
                    <CheckCircleOutlineIcon sx={{ color: 'green', fontSize: 40, mr: 1 }} />
                  ) : (
                    <WarningAmberIcon sx={{ color: 'orange', fontSize: 40, mr: 1 }} />
                  )}
                  <Typography variant="h6">Status: {liveStatus}</Typography>
                </Box>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  {accreditationData.message}
                </Typography>

                {accreditationData.status && (
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={approve}
                    onClick={performAccreditation}
                  >
                    Perform Accreditation
                  </Button>
                )}
              </>
            )}
          </CardContent>
        </Card>
      </Box>

      <Dialog open={dialogOpen} onClose={toggleDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Accreditation Details</DialogTitle>
        <DialogContent dividers>
          {loading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          ) : (
            <Box textAlign="center">
              <Typography variant="h6">
                Status: {accreditationData.accreditation_status}
              </Typography>
              <Typography>{accreditationData.message}</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={toggleDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      </IonContent>

    </IonPage>
  );
};

export default Accreditation;
